import {
  ComparisonTable as Table, ComparisonTableThemes, Button
} from 'member-web-shared-components';
import { ComparisonTableProps } from '../../types/App';
import './ComparisonTable.scss';

const ComparisonTable = (props: ComparisonTableProps) => {
  const {
    componentId,
    comparisonTableTitle,
    comparisonTableDescription,
    comparisonTableDisclaimer
  } = props;

  return (
    <div
      data-testid={componentId}
      className='presales-comparison-table'
    >
      <Table
        button={<Button priority='primary' linkButtonProps={{ url: '/pricing' }}>Join now</Button>}
        data={{
          comparisonHeaderItems: [
            {
              title: 'Zipcar'
            },
            { title: 'Peer-to-Peer Rental' }
          ],
          comparisonItems: [
            {
              title: 'Gas is included',
              comparison: [
                <img key='checkmark' alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img key='x' alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />
              ]
            },
            {
              comparison: [
                <img key='checkmark' alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img key='x' alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />
              ],
              title: 'Company maintained cars'
            },
            {
              comparison: [
                <img key='checkmark' alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img key='x' alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />
              ],
              title: 'Upfront pricing'
            },
            {
              comparison: [
                <img key='checkmark' alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img key='x' alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />
              ],
              title: 'More flexible trip cancellation'
            },
            {
              comparison: [
                <img key='checkmark' alt='Checkmark' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-checkmark.svg' />,
                <img key='x' alt='X' src='https://zipcar-drupal-prod.s3.amazonaws.com/drupal-presales/2023-09/presales-x.svg' />
              ],
              title: 'Trusted for 20+ years'
            }
          ]
        }}
        description={comparisonTableDescription}
        disclaimer={[comparisonTableDisclaimer]}
        title={comparisonTableTitle}
        theme={ComparisonTableThemes.DEFAULT}
      />
    </div>
  );
};

export default ComparisonTable;
